module.exports = parcelRequire.resolve("2z9NE");